import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Avatar1 from 'Components/ComponentLibrary/Components/Avatars/Avatar1';
import fr from 'facet-rest';

const styles = (theme) => ({
  root: {
    backgroundColor: theme.palette.common.white,
  },
});

const ImageAvatar = ({
  className,
  classes,
  resource,
}) => {
  return (
    <Avatar1
      className={classNames(classes.root, className)}
      src={resource.relationship(fr.relationships.image.name)?.link('related')?.url() || null}
    />
  );
};

ImageAvatar.defaultProps = {
  className: '',
};

ImageAvatar.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  resource: PropTypes.object.isRequired,
};

export default withStyles(styles)(ImageAvatar);
